module.exports = __webpack_public_path__ + "img/744.bab91f17.jpg";